function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

/**
 * Score interest vector for current user or (staff) another user / explicit interests.
 * @param {{ interests?: Array<{interest_id: string, choice: number}>, userId?: string }} params
 */
export async function fetchInterestClusterScores(params = {}) {
  const res = await fetch('/api/interest-test/score', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({
      ...(params.interests ? { interests: params.interests } : {}),
      ...(params.userId ? { userId: params.userId } : {})
    })
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error(data?.message || 'Failed to load interest cluster scores');
    err.status = res.status;
    err.code = data?.code;
    throw err;
  }
  return Array.isArray(data?.cluster_scores) ? data.cluster_scores : [];
}
